import React, { useEffect } from "react";
import { NoteData, NoteType } from "../../../../models/NoteData";
import { Button, Stack, TextField, Typography } from "@mui/material";

interface InstallerJobNotesProps {
    notes?: NoteData;
    onNoteChange: (note: NoteData) => void;
}

export const InstallerJobNotes = React.memo(({ notes, onNoteChange }: InstallerJobNotesProps) => {
    const [formNotes, setFormNotes] = React.useState<string>(notes?.note_text ?? "");
    const onSave = React.useCallback(() => {
        if (notes) {
            onNoteChange({
                ...notes,
                note_text: formNotes,
            });
        } else {
            onNoteChange({
                job_id: "",
                note_text: formNotes,
                note_type: NoteType.general,
                note_id: "",
            });
        }
    }, [formNotes, notes, onNoteChange]);
    useEffect(() => {
        if (notes) {
            setFormNotes(notes.note_text);
        }
    }, [notes]);
    return (
        <Stack>
            <Typography fontWeight={"bold"} variant={"subtitle2"} mb={4}>
                Any notes about incidents on the unit and its conditions?
            </Typography>
            <TextField
                fullWidth
                label="Notes"
                multiline
                rows={13}
                variant="filled"
                value={formNotes}
                onChange={(e) => setFormNotes(e.target.value)}
                placeholder="Type Here"
                helperText="Max 2000 characters"
                slotProps={{ htmlInput: { maxLength: 2000 } }}
                sx={{
                    "& .MuiFilledInput-root": {
                        backgroundColor: "white",
                        "&:hover": { backgroundColor: "white" },
                        "&.Mui-focused": { backgroundColor: "white" },
                    },
                }}
            />
            <Button
                className="basic-button"
                variant="contained"
                color="primary"
                sx={{ mt: 2 }}
                disabled={formNotes.length === 0}
                onClick={onSave}>
                Save
            </Button>
        </Stack>
    );
});
